import { useMemo } from 'react';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
// theme
import { hideScroll } from 'src/theme/css';
import { palette } from 'src/theme/palette';
// hooks
// import { useMockedUser } from 'src/hooks/use-mocked-user';
// components
import Logo from 'src/components/logo';
import { NavSectionMini } from 'src/components/nav-section';
//
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from '../_common';

// ----------------------------------------------------------------------

export default function NavMini() {
  // const { user } = useMockedUser();

  const navData = useNavData();

  const outerTheme = useTheme();

  // Same dark, colored background as the full vertical nav — see the note
  // in nav-vertical.js.
  const navTheme = useMemo(() => createTheme(outerTheme, { palette: palette('dark') }), [outerTheme]);

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <ThemeProvider theme={navTheme}>
        <Stack
          sx={{
            pb: 2,
            height: 1,
            position: 'fixed',
            width: NAV.W_MINI,
            bgcolor: 'background.default',
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
            ...hideScroll.x,
          }}
        >
          <Logo sx={{ mx: 'auto', my: 2 }} />

          <NavSectionMini
            data={navData}
            config={{
              //currentRole: user?.role || 'admin',
              currentRole: 'admin',
            }}
          />
        </Stack>
      </ThemeProvider>
    </Box>
  );
}
